import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/5">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_athletedev/artifacts/8k10kn7z_V1%20Athletics%20-%20Logo.svg" 
                alt="V1 Athletics Logo"
                className="h-16 w-auto"
              />
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed max-w-md">
              We support young athletes with a structured, long-term approach to physical 
              preparation, recovery, and mindset development — aligned with modern Long-Term 
              Athlete Development (LTAD) principles.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-zinc-400 text-sm hover:text-[#56C6C6] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-zinc-400 text-sm hover:text-[#56C6C6] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 text-sm hover:text-[#56C6C6] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-6">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#56C6C6] mt-1" />
                <span className="text-zinc-400 text-sm">info@v1athletics.com</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#56C6C6] mt-1" />
                <span className="text-zinc-400 text-sm">778 288 0857</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#56C6C6] mt-1" />
                <span className="text-zinc-400 text-sm">
                  White Rock, BC<br />
                  Canada
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-xs">
            © {currentYear} V1 Athletics. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-zinc-500 text-xs hover:text-zinc-300 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-zinc-500 text-xs hover:text-zinc-300 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
